import { render, staticRenderFns } from "./addSpecialMass.vue?vue&type=template&id=a1a12634&scoped=true&"
import script from "./addSpecialMass.vue?vue&type=script&lang=js&"
export * from "./addSpecialMass.vue?vue&type=script&lang=js&"
import style0 from "./addSpecialMass.vue?vue&type=style&index=0&id=a1a12634&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a12634",
  null
  
)

export default component.exports